import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Creating Unforgettable Weddings, Just For You"} subTitle={"Plan Your Dream Wedding"} linear sideHeading />
        <Button link={"Booking"} title={"Start Planning"} />

      </div>
    </section>
  );

};

export default Banner;